// extracted by mini-css-extract-plugin
module.exports = {"scrollableContent":"activity-feed_scrollableContent_1iYPu","message":"activity-feed_message_3THsh","emptyResult":"activity-feed_emptyResult_3bp5Y"};